export const draft = 'draft';
export const publish = 'publish';
export const onboard = 'onboard';
